import { spacing } from '@gyym/ui'
import styled, { css } from 'styled-components'

export const Container = styled.div<{ mt?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ mt }) =>
    mt &&
    css`
      margin-top: ${spacing(mt)};
    `};
`
